export const convertTjToMwh = (tj: number) => {
  return tj / 0.0036
}

export const convertMwhToTj = (mwh: number) => {
  return mwh * 0.0036
}
